import { FC } from 'react';
import { Spinner } from 'react-bootstrap';
import classNames from 'classnames';

interface LoadingSpinnerProps {
  isLoading: boolean;
  children: React.ReactNode;
}

const LoadingSpinner: FC<LoadingSpinnerProps> = (props) => {
  const { children = null, isLoading = false } = props;
  const spinnerContainerClassNames = classNames('spinner-container', { show: isLoading });

  return (
    <div className="common-component-loading-spinner">
      <div className={spinnerContainerClassNames} role="spinner">
        <Spinner variant="primary" className="spinner" animation="border" />
      </div>
      {!isLoading && children}
    </div>
  );
};

export default LoadingSpinner;
